// needs refactor out of global scope
const collNav = document.querySelector('.collection__nav');
let scrollPos = 0; // Watched position
let diffInScroll = 0; // Change in scroll
const secMenuWrapper = document.querySelector('.secondary-menu-wrapper');
const collFilterOuter = document.querySelector('.collection__filters__outer');
// const navHeight = nav.clientHeight;
const collHeroTextElement =
  document.querySelector('.collection__text-content') || [];
const collHeroTextHeight = collHeroTextElement.clientHeight || 0;
const collHero = document.getElementById('collection-hero');
var collHeroContentHeight = collHeroTextHeight;

if (collHero !== null) {
  var collHeroHeight = collHero.clientHeight;
  collHeroContentHeight = collHeroTextHeight + collHeroHeight;
}

// Hides the secret menu and handles the show/hide logic for UTM parameters
function hideSecretMenu() {
  const hiddenGlobalMenu = document
    .querySelector('[data-hidden-menu]')
    ?.getAttribute('data-hidden-menu');
  const hiddenCatNavMenu = document
    .querySelector('[data-hidden-cat-nav-menu]')
    ?.getAttribute('data-hidden-cat-nav-menu');

  const showHiddenMenu = sessionStorage.getItem('showHiddenMenu');
  if (hiddenGlobalMenu != null && hiddenCatNavMenu != null) {
    [...document.querySelectorAll('.subLink')].forEach(function (item) {
      //covers cases where the cat nav + global nav menu items to hide have the same id
      //and when they have different ids
      if (
        item.id == hiddenGlobalMenu ||
        item.id == hiddenCatNavMenu ||
        hiddenCatNavMenu.includes(item.id)
      ) {
        //hide cat nav item if its id is set in admin
        item.classList.add('hidden-menu');
      }
      if (showHiddenMenu) {
        //show cat nav item, if user came from correct UTM link
        item.classList.remove('hidden-menu');
      }
    });
  }
}

// Focus search field when search icon is clicked
function focusSearchField() {
  const searchIcon = document.querySelector('.search-icon');
  const searchField = document.querySelector(
    '#search-popdown .live-search-form .live-search-form-field',
  );

  if (searchIcon && searchField) {
    searchIcon.addEventListener('click', () => {
      searchField.focus();
    });
  }
}
document.addEventListener('DOMContentLoaded', debounce(focusSearchField));

//Controls scrolling navs on search page
//needs reworking and remove classe
var searchField = document.getElementById('fs-search-field');
function handleSearchScroll() {
  if (scrollPos > 50) {
    searchField.style.position = 'fixed';
    searchField.classList.add('scrolledSearch');
    collNav.classList.add('collNavSearchScroll');
    collNav.classList.add('collNavTop70');
  } else {
    searchField.style.position = 'static';
    searchField.classList.remove('scrolledSearch');
    collNav.classList.remove('collNavSearchScroll');
    collNav.classList.remove('collNavTop70');
  }
}
if (searchField !== null) {
  window.addEventListener('scroll', debounce(handleSearchScroll));
}

// need to rework this
function checkPosition() {
  let nav = document.querySelector('.theme__header');
  let navHeader = document.querySelector('.js__header__stuck');
  let windowY = window.scrollY; // Current Y position

  if (windowY < scrollPos) {
    // Scrolling UP
    if (diffInScroll < -50) {
      if (searchField) {
        searchField.classList.add('scrolledSearchHackyFix');
      }
      if (secMenuWrapper) {
        secMenuWrapper?.classList.add('secondary-menu-wrapper-animate');
        secMenuWrapper?.classList.remove('zIndex6001Desktop');
        collNav.classList.add('collection__nav_animate');
        if (navHeader) {
          navHeader.style.zIndex = '6004';
        }
      } else {
        collNav.classList.remove('collection__nav_animate_search');
        collFilterOuter.classList.add('navTop100');
        navHeader?.classList.remove('zIndexAdjuster');
        secMenuWrapper?.classList.remove('zIndex6001Desktop');
      }
      collFilterOuter.classList.add('coll-filter-top-150');
      diffInScroll = 0;
      // nav.classList.remove('navTop20');
      if (windowY > collHeroContentHeight) {
        nav.classList.add('navTopAnimation');
        nav.classList.remove('navTopNegative55');
      }
      [...document.querySelectorAll('.header__dropdown')].forEach(
        function (item) {
          item.classList.remove('is-visible');
        },
      );
    } else {
      diffInScroll = diffInScroll + (windowY - scrollPos);
    }
  } else {
    // Scrolling DOWN
    if (diffInScroll > 50) {
      if (searchField) {
        searchField.classList.remove('scrolledSearchHackyFix');
        collNav.classList.remove('collNavSearchScroll');
      }
      if (secMenuWrapper) {
        secMenuWrapper?.classList.remove('secondary-menu-wrapper-animate');
        collNav.classList.remove('collection__nav_animate');
      } else {
        collNav.classList.add('collection__nav_animate_search');
        collFilterOuter.classList.remove('navTop100');
        navHeader?.classList.add('zIndexAdjuster');
      }
      collFilterOuter.classList.remove('coll-filter-top-150');
      if (scrollPos > collHeroContentHeight) {
        nav.classList.remove('navTopAnimation');
        nav.classList.add('navTopNegative55');
      }
      [...document.querySelectorAll('.header__dropdown')].forEach(
        function (item) {
          item.classList.remove('is-visible');
        },
      );
    } else {
      diffInScroll = diffInScroll + (windowY - scrollPos);
    }
  }

  let announcementBar = document.querySelector('.announcement__wrapper');
  if (window.scrollY < 5 && announcementBar) {
    //console.log("window scroll", window.scrollY)
    nav.classList.remove('navTopNegative55');
    nav.classList.remove('navTopAnimation');
    // nav.classList.add('navTop20');
  } else {
    // nav.classList.remove('navTopAnimation');
    // nav.classList.remove('navTop20');
  }

  if (scrollPos < collHeroContentHeight) {
    if (secMenuWrapper) {
      secMenuWrapper?.classList.remove('zIndex6001Desktop');
    }
  }

  if (secMenuWrapper && scrollPos > collHeroContentHeight) {
    secMenuWrapper.style.paddingTop = 0.4 + 'rem';
    secMenuWrapper.style.paddingBottom = 0.45 + 'rem';
    secMenuWrapper?.classList.add('zIndex6001Desktop');
  }

  //Z index for secondary menu
  if (secMenuWrapper && scrollPos > collHeroContentHeight) {
    secMenuWrapper?.classList.add('zIndex6001Mobile');
    // nav.style.top = -navHeight + 'px';
  }
  if (secMenuWrapper && scrollPos < collHeroContentHeight) {
    secMenuWrapper?.classList.remove('zIndex6001Mobile');
    // nav.classList.add('navTopAnimation');
  }

  // console.log(scrollPos)
  scrollPos = windowY; // New watched position
}

if (collNav !== null) {
  //console.log('collNav', collNav);
  window.addEventListener('scroll', debounce(checkPosition));
}
// need to rework this

// validate this is not used in other places then remove
function handleFloatingFooterContent() {
  document.addEventListener('theme:scroll:lock', function () {
    document.dispatchEvent(new CustomEvent('chat:hide', { bubbles: true }));
  });

  document.addEventListener('theme:scroll:unlock', function () {
    document.dispatchEvent(new CustomEvent('chat:show', { bubbles: true }));
  });

  document.addEventListener('chat:hide', function () {
    var chat = document.getElementById('gorgias-chat-container');
    if (chat) {
      chat.style.display = 'none';
    }
    var modal = document.getElementById('attentive_creative');
    if (modal) {
      modal.style.display = 'none';
    }
    var cookieBanner = document.getElementById('site-cb-footer');
    if (cookieBanner) {
      //console.log('cookieBanner', cookieBanner);
      cookieBanner.classList.add('hidden-bar');
    }
  });

  document.addEventListener('chat:show', function () {
    var chat = document.getElementById('gorgias-chat-container');
    chat.style.display = 'block';
    var modal = document.getElementById('attentive_creative');
    if (modal) {
      modal.style.display = 'block';
    }
    var cookieBanner = document.getElementById('site-cb-footer');
    if (cookieBanner) {
      //console.log('cookieBanner', cookieBanner);
      //cookieBanner.classList.remove('hidden-bar');
    }
  });
}
handleFloatingFooterContent();

function handleHamburgerMenu() {
  // Lock scroll when mobile menu nav drawer is open
  var hamburgerMobileMenuOpen = document.querySelector(
    '.header__mobile__button',
  );
  var mobileMenuClose = document.querySelector('.drawer__close');
  var bodyEl = document.body;

  hamburgerMobileMenuOpen.addEventListener('click', bodyFixed);

  mobileMenuClose.addEventListener('click', bodyFixed);

  function bodyFixed() {
    bodyEl.classList.toggle('fixed-position');
  }
}
handleHamburgerMenu();

// moved from collection-fs.liquid
// checks if collection page cat navigation is on page and then handles the scroll event for the cat navigation
function handleCatNavScroll() {
  //console.log('handleCatNavScroll');
  let scrollPos2 = 0; // Watched position
  let diffInScroll2 = 0; // Change in scroll
  const menuWrapper2 = document.querySelector('.secondary-menu-wrapper');

  if (menuWrapper2 !== null && collNav !== null) {
    window.addEventListener('scroll', function () {
      let windowY2 = window.scrollY; // Current Y position
      if (windowY2 < scrollPos2) {
        // If current position is less than current watched position
        // Scrolling UP
        if (diffInScroll2 < -50) {
          menuWrapper2?.classList.add('top-55');
          collNav?.classList.add('top-110');
          diffInScroll2 = 0;
        } else {
          diffInScroll2 = diffInScroll2 + (windowY2 - scrollPos2);
        }
      } else {
        // Scrolling DOWN
        if (diffInScroll2 > 50) {
          menuWrapper2?.classList.remove('top-55');
          collNav?.classList.remove('top-110');
        } else {
          diffInScroll2 = diffInScroll2 + (windowY2 - scrollPos2);
        }
      }
      scrollPos2 = windowY2; // New watched position
    });
  }
}

// Candidates for moving to a utility function
function isCollectionPage() {
  return document.querySelector('body.template-collection') !== null;
}

function debounce(func, wait = 10, immediate = true) {
  let timeout;
  return function () {
    let context = this,
      args = arguments;
    let later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    let callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
//

/*
 * page start logic
 */

// Checks if the current page is a collection page and then handles the scroll event for the cat navigation
(function () {
  //console.log('page start logic');
  if (isCollectionPage()) {
    handleCatNavScroll();
  }

  // check if the secret menu content exists and handle the show/hide logic
  const secretMenuContent = document.querySelector('[data-hidden-menu]');
  if (secretMenuContent != null) {
    secretMenuContent.addEventListener('DOMContentLoaded', hideSecretMenu());
  }
})();

/* removed to be deleted if not needed
  // hanbdle pdpd swatch bounce issue
  document.querySelectorAll('.swatches.product-image').forEach((el) => {
    console.log('swatch found');
    if (el != null) {
      el.style.height = '67px';
    }
  });
*/
